<template>
  <div class="login-form">
    <div class="login-form-content">
      <div class="close-button mobile-only">
        <a class="icon-close" @click.prevent="closeModal"> </a>
      </div>
      <form id="password-change-form" class="login-form-login-section">
        <h1 class="heading heading__sm">Change <span class="yellow-line">password</span></h1>
        <div class="form-group">
          <label for="password">Current Password</label>
          <input
            type="password"
            class="form-control"
            name="currentPassword"
            data-validation="required length"
            data-validation-length="8-100"
            autocomplete="new-password"
            v-model="formData.currentPassword"
          />
        </div>
        <div class="form-group">
          <label for="password">Enter new password</label>
          <input
            type="password"
            class="form-control"
            name="password"
            data-validation="required length"
            data-validation-length="8-100"
            autocomplete="new-password"
            v-model="formData.password"
          />
        </div>
        <div class="form-group">
          <label for="confirm_password">Repeat new password</label>
          <input
            type="password"
            class="form-control"
            id="confirm_password"
            name="pass"
            data-validation="required confirmation"
            data-validation-confirm="password"
            data-validation-length="8-100"
            data-validation-error-msg="Password does not match with repeat password"
            autocomplete="new-password"
            v-model="change.confirmPassword"
          />
        </div>
        <div class="row button-row">
          <div class="col-xs-12 col-sm-6">
            <button type="submit" class="btn btn-sm btn-yellow btn-submit" @click.prevent="changePassword">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="login-form-image">
      <div class="close-button">
        <a class="icon-close" @click.prevent="closeModal"> </a>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '../auth'
import config from '../conf'
export default {
  name: 'Login',
  data: function () {
    return {
      change: {
        password: '',
        confirmPassword: '',
      },
      formData: {
        email: '',
        currentPassword: '',
        password: '',
      },
    }
  },
  mounted: function () {
    var self = this
    $.validate({
      form: '#password-change-form',
      modules: 'security html5',
      validateHiddenInputs: true,
      scrollToTopOnError: true,
      onSuccess: function ($form) {
        self.changePassword()
        return false
      },
    })
  },
  methods: {
    changePassword: function () {
      if (this.formData.password === this.change.confirmPassword && this.formData.password !== '') {
        var user_id = localStorage.getItem('afripodsLoggedInUserId')
        this.formData.email = localStorage.getItem('afripodsLoggedInUserEmail')
        this.$http
          .put(config.url.podcaster_users + '/' + user_id, this.formData, {
            params: {},
            headers: auth.getAuthHeader(),
          })
          .then(
            function (response) {
              if (response.status == 200) {
                this.$notify({
                  title: 'Success!',
                  text: 'Password changed successfully!',
                  type: 'success',
                })
                document.getElementById('changePasswordModal').remove()
                document.getElementsByClassName('modal-backdrop')[0].remove()
                this.formData.password = ''
                this.change.confirmPassword = ''
                this.formData.currentPassword = ''
              }
            },
            function (e) {
              this.$notify({
                title: 'Something went wrong!',
                text: this.getErrorMessage(e),
                type: 'error',
              })
            }
          )
      }
    },
    closeModal: function () {
      this.formData.password = ''
      this.formData.currentPassword = ''
      this.change.confirmPassword = ''
      $('#changePasswordModal').modal('hide')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue